function formateDate(unixtime) {
    if(!unixtime){
        unixtime =  Date.now();
    }
    var d = new Date(parseInt(unixtime)); // 依情况进行更改 * 1
    return (d.getFullYear()) + '-' + (d.getMonth() + 1 > 9 ? d.getMonth() + 1 : '0' + (d.getMonth() + 1)) + '-' + (d.getDate() > 9 ? d.getDate() : '0' + d.getDate());
}
function getTodayDate() {
	var date = new Date();
	let today = date.getFullYear() + "-" + addo(date.getMonth() + 1) + "-" + addo(date.getDate());
	return today
}

function addo(time) {
	let result = time < 10 ? "0" + time : time;
	return result;
}
export {
    formateDate,
    getTodayDate
}